import ChatInbox from './container';

export default ChatInbox;
